import eprNewArchitectureReducer from './eprNewArchitectureSlice'

export default eprNewArchitectureReducer
